export abstract class ServerService {
    public abstract get request(): any;
    public abstract get response(): any;
    public abstract get logFn(): any;
}
